import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { UtmSource } from "@/helpers/interfaces/UtmSource.ts";

const VALID_SOURCES = Object.values(UtmSource) as string[];

export const detectUtmSourceParam = (): UtmSource | undefined => {
  const value = new URLSearchParams(window.location.search).get(URLParam.UtmSource);
  return value && VALID_SOURCES.includes(value) ? (value as UtmSource) : undefined;
};
